import { render } from "./PowerupsV4.vue?vue&type=template&id=4ab61222&scoped=true"
import script from "./PowerupsV4.vue?vue&type=script&lang=js"
export * from "./PowerupsV4.vue?vue&type=script&lang=js"

import "./PowerupsV4.vue?vue&type=style&index=0&id=4ab61222&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ab61222"]])

export default __exports__